const vatDeclarationsSelector = (state) => state.vatDeclaration.vatDeclarations

export { vatDeclarationsSelector }
